<mat-card>
    <h1 class="subtitle col-md-12">{{texteService.getTexte('TITLE_PATIENT')}}</h1>
    <mat-card-content class="col-md-12">
        <form [formGroup]="patientForm">
            <!-- Demande : autre -->
            <div class="form-row d-flex align-self-center"
                *ngIf="typesSelected.situation.code === 'FRA' && typesSelected.demande === null">
                <label for="patient-dossier" class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_PATIENT_NUMERO')}}<span
                        class="red-label">*</span></label>
                <mat-form-field class="input-form col-md-7">
                    <input id="patient-dossier" matInput type="text" name="dossier" formControlName="dossier" />
                    <mat-icon (click)="numDossierTooltip.show()" #numDossierTooltip="matTooltip" matSuffix
                        matTooltip="{{texteService.getTexte('TOOLTIP_PATIENT_NUM')}}">
                        info</mat-icon>
                    <mat-error
                        *ngIf="patientForm.controls.dossier.touched && patientForm.controls.dossier.hasError('required')">
                        {{texteService.getTexte('ERR_LABEL_PATIENT_NUMERO_REQUIRED')}}</mat-error>
                    <mat-error
                        *ngIf="patientForm.controls.dossier.touched && patientForm.controls.dossier.hasError('dossierUnvalid')">
                        {{texteService.getTexte('ERR_LABEL_PATIENT_NUMERO_UNVALID')}}</mat-error>
                </mat-form-field>
            </div>

            <div class="form-row d-flex align-self-center">
                <label for="patient-nom" class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_NOM')}}<span
                        class="red-label">*</span></label>
                <mat-form-field class="input-form col-md-7">
                    <input id="patient-nom" matInput type="text" name="nom" formControlName="nom" />
                    <mat-error
                        *ngIf="patientForm.controls.nom.touched && patientForm.controls.nom.hasError('required')">
                        {{texteService.getTexte('ERR_PATIENT_NOM_REQUIRED')}}</mat-error>
                </mat-form-field>
            </div>

            <div class="form-row d-flex align-self-center">
                <label for="patient-nom2" class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_PATIENT_NOM_2')}}</label>
                <mat-form-field class="input-form col-md-7">
                    <input id="patient-nom2" matInput type="text" name="nom2" formControlName="nom2" />
                </mat-form-field>
            </div>

            <div class="form-row d-flex align-self-center">
                <label for="patient-prenom" class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_PRENOM')}}<span
                        class="red-label">*</span></label>
                <mat-form-field class="input-form col-md-7">
                    <input id="patient-prenom" matInput type="text" name="prenom" formControlName="prenom" />
                    <mat-error
                        *ngIf="patientForm.controls.prenom.touched && patientForm.controls.prenom.hasError('required')">
                        {{texteService.getTexte('ERR_PATIENT_PRENOM_REQUIRED')}}</mat-error>
                </mat-form-field>
            </div>

            <div class="form-row d-flex align-self-center">
                <span id="patient-sexe-label" class="col-md-5 align-self-center form-label">{{texteService.getTexte('LABEL_PATIENT_SEXE')}}<span
                        class="red-label">*</span></span>
                <div class="col-md-7">
                    <mat-radio-group name="sexe" formControlName="sexe" aria-labelledby="patient-sexe-label">
                        <mat-radio-button value="H">{{texteService.getTexte('LABEL_PATIENT_SEXE_HOMME')}}
                        </mat-radio-button>
                        <mat-radio-button value="F">{{texteService.getTexte('LABEL_PATIENT_SEXE_FEMME')}}
                        </mat-radio-button>
                    </mat-radio-group>
                    <mat-error
                        *ngIf="patientForm.controls.sexe.touched && patientForm.controls.sexe.hasError('required')">
                        {{texteService.getTexte('ERR_PATIENT_SEXE_REQUIRED')}}</mat-error>
                </div>
            </div>

            <div class="form-row d-flex align-self-center">
                <label for="patient-date-naissance" class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_PATIENT_DATE_NAISSANCE')}}<span
                        class="red-label">*</span></label>
                <mat-form-field class="input-form col-md-7">
                    <input id="patient-date-naissance" readonly (click)="dateNaissancePicker.open()" matInput [matDatepicker]="dateNaissancePicker"
                        formControlName="dateNaissance">
                    <mat-datepicker-toggle matSuffix [for]="dateNaissancePicker"></mat-datepicker-toggle>
                    <mat-datepicker #dateNaissancePicker></mat-datepicker>
                    <mat-error
                        *ngIf="patientForm.controls.dateNaissance.touched && patientForm.controls.dateNaissance.hasError('required')">
                        {{texteService.getTexte('ERR_PATIENT_DATE_NAISSANCE_REQUIRED')}}</mat-error>
                </mat-form-field>
            </div>

            <!-- Situation : Internationnal -->
            <div *ngIf="typesSelected.situation.code === 'INT'">
                <div class="form-row d-flex align-self-center">
                    <label for="patient-adresse" class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_PATIENT_ADRESSE')}}<span
                            class="red-label">*</span></label>
                    <mat-form-field class="input-form col-md-7">
                        <input id="patient-adresse" matInput type="text" name="adresse" formControlName="adresse" />
                        <mat-error
                            *ngIf="patientForm.controls.adresse.touched && patientForm.controls.adresse.hasError('required')">
                            {{texteService.getTexte('ERR_PATIENT_ADRESSE_REQUIRED')}}</mat-error>
                    </mat-form-field>
                </div>

                <div class="form-row d-flex align-self-center">
                    <label for="patient-ville" class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_PATIENT_VILLE')}}<span
                            class="red-label">*</span></label>
                    <mat-form-field class="input-form col-md-3">
                        <input id="patient-ville" matInput type="text" name="ville" formControlName="ville" />
                        <mat-error
                            *ngIf="patientForm.controls.adresse.touched && patientForm.controls.adresse.hasError('required')">
                            {{texteService.getTexte('ERR_PATIENT_ADRESSE_REQUIRED')}}</mat-error>
                    </mat-form-field>

                    <span id="patient-pays-label" class="col-md-1 align-self-center form-label">{{texteService.getTexte('LABEL_PATIENT_PAYS')}}<span
                            class="red-label">*</span></span>

                    <mat-form-field class="col-md-3">
                        <mat-label>{{texteService.getTexte('LABEL_SELECT')}}</mat-label>
                        <mat-select formControlName="pays" (selectionChange)="onPaysChange()" aria-labelledby="patient-pays-label">
                            <mat-option *ngFor="let p of pays" [value]="p">
                               {{p.indicatifs | indicatif}} {{ p.libelle }}
                            </mat-option>
                        </mat-select>
                        <mat-error
                            *ngIf="patientForm.controls.pays.touched && patientForm.controls.pays.hasError('required')">
                            {{texteService.getTexte('ERR_PATIENT_PAYS_REQUIRED')}}</mat-error>
                    </mat-form-field>
                </div>

                <div class="form-row d-flex align-self-center">
                    <label for="patient-nationnalite"
                        class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_PATIENT_NATIONNALITE')}}<span
                            class="red-label">*</span></label>
                    <mat-form-field class="input-form col-md-7">
                        <input id="patient-nationnalite" matInput type="text" name="nationnalite" formControlName="nationnalite" />
                        <mat-error
                            *ngIf="patientForm.controls.nationnalite.touched && patientForm.controls.nationnalite.hasError('required')">
                            {{texteService.getTexte('ERR_PATIENT_NATIONNALITE_REQUIRED')}}</mat-error>
                    </mat-form-field>
                </div>

                <div class="form-row d-flex align-self-center">
                    <span id="patient-visa-label" class="col-md-5 align-self-center form-label">{{texteService.getTexte('LABEL_PATIENT_VISA')}}<span
                            class="red-label">*</span></span>
                    <div class="col-md-7">
                        <mat-radio-group name="visa" formControlName="visa" aria-labelledby="patient-visa-label">
                            <mat-radio-button value="true">{{texteService.getTexte('LABEL_OUI')}}</mat-radio-button>
                            <mat-radio-button value="false">{{texteService.getTexte('LABEL_NON')}}</mat-radio-button>
                        </mat-radio-group>
                        <mat-error
                            *ngIf="patientForm.controls.visa.touched && patientForm.controls.visa.hasError('required')">
                            {{texteService.getTexte('ERR_PATIENT_VISA_REQUIRED')}}</mat-error>
                    </div>
                </div>
            </div>

            <!-- Situation : Médecin -->
            <div *ngIf="typesSelected.situation.code === 'MED'">
                <div class="form-row d-flex align-self-center">
                    <label for="patient-telephone" class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_TEL_PORT')}}<span
                            class="red-label">*</span></label>
                    <mat-form-field class="input-form col-md-7">
                        <input id="patient-telephone" matInput type="tel" name="telephone" formControlName="telephone" />
                        <mat-error
                            *ngIf="patientForm.controls.telephone.touched && patientForm.controls.telephone.hasError('required')">
                            {{texteService.getTexte('ERR_PATIENT_TEL_REQUIRED')}}</mat-error>
                        <mat-error
                            *ngIf="patientForm.controls.telephone.touched && patientForm.controls.telephone.hasError('telUnvalid')">
                            {{texteService.getTexte('ERR_TEL_UNVALID')}}</mat-error>
                    </mat-form-field>
                </div>

                <div class="form-row d-flex align-self-center">
                    <label for="patient-telephone2" class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_PATIENT_TEL_2')}}</label>
                    <mat-form-field class="input-form col-md-7">
                        <input id="patient-telephone2" matInput type="tel" name="telephone2" formControlName="telephone2" />
                        <mat-error
                            *ngIf="patientForm.controls.telephone2.touched && patientForm.controls.telephone2.hasError('telUnvalid')">
                            {{texteService.getTexte('ERR_TEL_UNVALID')}}</mat-error>
                    </mat-form-field>
                </div>

                <div class="form-row d-flex align-self-center">
                    <label for="patient-email" class="col-md-5 align-self-center">{{texteService.getTexte('LABEL_EMAIL')}}</label>
                    <mat-form-field class="input-form col-md-7">
                        <input id="patient-email" matInput type="email" name="email" formControlName="email" />
                        <mat-error
                            *ngIf="patientForm.controls.email.touched && patientForm.controls.email.hasError('email')">
                            {{texteService.getTexte('ERR_EMAIL_UNVALID')}}</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </form>
    </mat-card-content>
</mat-card>
